<template>
  <div>
    <ValidationObserver v-slot="{ invalid, validate, errors }">
      <form class="space-y-6 p-3" @submit.prevent="validate().then(() => onSubmit(invalid))">
        <div class="flex">
          <span class="p-2 text-sm text-gray-500 bg-gray-100 rounded-md">
            Use this form for partial or complete cancellation of transportation. If a student just won't be riding on a particular day, please contact our office at {{ contactPhone }} or transportation@drivecst.org
          </span>
        </div>
        <div class="grid grid-cols-2 gap-3">
          <div>
            <label>Name</label>
            <Input
              type="text"
              class="w-full rounded-md !shadow"
              v-model="data.name"
              disabled
            />
          </div>
          <div>
            <label>Student ID</label>
            <Input
              type="text"
              class="w-full rounded-md !shadow"
              v-model="data.studentId"
              disabled
            />
          </div>
        </div>
        <ValidationProvider rules="required|todayAndFuture" name="endDate" v-slot="{ errors }">
          <div>
            <label>Last day of transportation</label>
            <Input
              type="date"
              class="w-full rounded-md !shadow"
              :min="getTodayDate"
              v-model="data.endDate"
            />
            <span
              class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
              {{ errors[0] }}
            </span>
          </div>
        </ValidationProvider>
        <div class="flex flex-col">
          <div>Please select the transportation directions you want to cancel: </div>
          <ValidationProvider rules="required" name="direction" v-slot="{ errors }">
            <div class="flex flex-row mt-2">
              <label class="m-2">
                <input
                  type="radio"
                  value="I"
                  class="rounded-md !shadow mx-2"
                  v-model="data.direction"
                />
                Inbound (to school)
              </label>
            </div>
            <div class="flex flex-row">
              <label class="m-2">
                <input
                  type="radio"
                  value="O"
                  class="rounded-md !shadow mx-2"
                  v-model="data.direction"
                />
                Outbound (from school)
              </label>
            </div>
            <div class="flex flex-row">
              <label class="m-2">
                <input
                  type="radio"
                  value="B"
                  class="rounded-md !shadow mx-2"
                  v-model="data.direction"/>
                Both
              </label>
            </div>
            <span
              class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
              {{ errors[0] }}
            </span>
          </ValidationProvider>
        </div>
        <div>
          <label>Additional information: </label>
          <Textarea class="w-full !min-h-[4rem] rounded-md !shadow" v-model="data.notes" />
        </div>
        <div>
          <div class="w-full rounded-md bg-gray-200 p-2 my-2"
            v-if="!canSubmit">
            <span class="uppercase text-gray-500">
              Missing Permissions to Submit Form
            </span>
          </div>
          <div class="flex flex-row">
            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
              v-if="displayFormHasErrors(errors)">
              There are errors in fields above.
            </span>
          </div>
          <SubmitButton
            type="submit"
            color="blue"
            size="md"
            class="rounded-md font-medium text-white bg-sky-600 px-3 py-2 hover:bg-blue-200 transition-colors shadow-sm"
            :disabled="!canSubmit"
            :submitting="submitting">
            Submit Cancellation
          </SubmitButton>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import Input from '../components/Input.vue'
import Textarea from '../components/Textarea.vue'
import SubmitButton from '../components/SubmitButton.vue'

import '../services/validation.js'

import cancelFormService from '../services/pages/cancelRequestForm.js'

import partitions from '../services/partitions.js'
import user from '../services/user/user.js'
import time from '../services/utils/time.js'
import events from '../services/events.js'

import { localize } from 'vee-validate'

localize({
  en: {
    fields: {
      endDate: {
        required: 'Last day of transportation is required',
      },
      direction: {
        required: 'Direction is required',
      },
    }
  }
})

export default {
  components: {
    Input,
    Textarea,
    SubmitButton
  },
  props: {
    studentInfo: Object,
    closeModal: Function,
  },
  data() {
    return {
      data: {
        user: undefined,

        name: `${this.studentInfo.firstName} ${this.studentInfo.lastName}`,
        studentId: this.studentInfo.studentId,
        endDate: null,
        notes: '',
        submissionPromise: undefined,
      },
      contactPhone: '---',

      canSubmit: true,
      submitting: false,
    }
  },
  methods: {
    onSubmit(formInvalid) {
      if (formInvalid) {
        return false
      }

      this.submitting = true

      if (this.submissionPromise) {
        return false
      }

      this.submissionPromise = cancelFormService.postNewCancelForm(this.data, this.studentInfo.dbId)
        .then(() => {
          this.$emit('closeModal')
          events.trigger('viewUpdated')
        })
        .finally(() => {
          this.submitting = false
          this.submissionPromise = undefined
        })
      return true
    },
    getTodayDate() {
      return time.today()
    },
    endDateValidate() {
      let tmr = new Date()
      // Add a day
      tmr.setDate(tmr.getDate() - 1)
      return new Date(this.data.endDate) < tmr
    },
    displayFormHasErrors(errorsMap) {
      return Object.values(errorsMap).flat().length > 0
    },
    async validateProvidedInfo() {
      this.canSubmit = cancelFormService.canSubmitForm(this.user)
    },
  },
  async mounted() {
    this.contactPhone = '---'

    await partitions.getPartitionFromServer()
    let contactPhone = await partitions.getPartitionContactPhone(this.studentInfo.partitionId, 'district_phone')

    this.contactPhone = contactPhone

    this.user = await user.get()
    this.validateProvidedInfo()
  }
}
</script>
